import httpService from "@/utils/services/http_service";

export default {
  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async memberList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async addMember(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async editMember(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  管理员列表
   */
  async deleteMember(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async appList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_list',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async addApp(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_create',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async editApp(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_edit',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async deleteApp(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_delete',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-04
   *  管理员列表
   */
  async resetToken(data = {}) {
    return httpService.post(
      '/api.php?do=admin_app_token_reset',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-04-02
   *  疫情信息地区信息列表
   */
  async epidemicList(data = {}) {
    return httpService.post(
      '/api.php?do=admin_yq_area_list',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-04-02
   *  疫情信息地区基本信息
   */
  async epidemicBase(data = {}) {
    return httpService.post(
      '/api.php?do=admin_yq_area_info',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-04-02
   *  疫情信息地区编辑
   */
  async areaFormSubmit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_yq_area_edit',
      data
    )
  },

  /**
   * @author: lafitewu
   * date: 2020-04-02
   *  疫情数据列表页面-国家
   */
  async epidemicDatas(data = {}) {
    return httpService.post(
      '/api.php?do=admin_yq_data_area_info',
      data
    )
  },

   /**
   * @author: lafitewu
   * date: 2020-04-02
   *  疫情数据列表页面-国家
   */
  async epidemicDatasEdit(data = {}) {
    return httpService.post(
      '/api.php?do=admin_yq_data_area_edit',
      data
    )
  },

}
